export default __webpack_public_path__ + "static/blob-13-8e51a1dd39f199671aed31e5047576d1.svg";